/*
 *******************************************************************************
 * 
 *  Filename:   ./agents/agentUsers.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Agent for Users API endpoints.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 8:18 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      09/19/2018  NJN     Added UserRoles
 *      10/29/2018  NJN     Add companyid
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import { requests } from './requests';

export const Users = {
    all: (companyid, userstatusid) => requests.get(`/Users?companyid=${companyid ? companyid : 0}&userstatusid=${userstatusid ? userstatusid : 0}`),
    get: userid => requests.get(`/User/${userid}`),
    create: user => requests.post(`/Users`, user),
    update: (userid, user) => requests.put(`/User/${userid}`, user),
    delete: userid => requests.del(`/User/${userid}`),
    changePassword: (userid, password) => requests.post(`/ChangePassword/${userid}`, password),
    sendUserStatus: (userid) => requests.post(`/SendUserStatus`, userid)
};

export const UserStatuses = {
    all: () => requests.get('/UserStatuses'),
    get: userstatusid => requests.get(`/UserStatus/${userstatusid}`),
    create: userstatus => requests.post(`/UserStatuses`, userstatus),
    update: (userstatusid, userstatus) => requests.put(`/UserStatus/${userstatusid}`, userstatus),
    delete: userstatusid => requests.del(`/UserStatus/${userstatusid}`),
};

export const UserRoles = {
    all: userid => requests.get(`/UserRoles?action=all&userid=${userid ? userid : 0}`),
    save: (payload) => requests.post(`/UserRoles`, payload)
};


// WEBPACK FOOTER //
// ./src/agents/agentUsers.js